"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subsidy = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const lodash_1 = require("lodash");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
let Subsidy = class Subsidy {
    _id = (0, uuid_1.v4)();
    value;
    currency = legacy_enums_1.Currency.Euro;
    managementNote;
    description;
    category;
    subcategory;
    createdAt = new Date();
    get displayDescription() {
        return [legacy_enums_1.SubsidyCategories[this.category], legacy_enums_1.SubsidySubcategories[this.category]?.[this.subcategory], this.description]
            .filter(Boolean)
            .join(" / ");
    }
};
exports.Subsidy = Subsidy;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Subsidy.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Subsidy.prototype, "value", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Subsidy.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Subsidy.prototype, "managementNote", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ValidateIf)((s) => s.category === legacy_enums_1.SubsidyCategory.OTHER || s.subcategory === legacy_enums_1.SubsidySubcategory.OTHER),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Subsidy.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Subsidy.prototype, "category", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ValidateIf)((s) => !(0, lodash_1.isEmpty)(legacy_enums_1.SubsidySubcategories[s.category])),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Subsidy.prototype, "subcategory", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Subsidy.prototype, "createdAt", void 0);
exports.Subsidy = Subsidy = __decorate([
    (0, typeorm_1.Entity)("subsidies")
], Subsidy);
//# sourceMappingURL=Subsidy.js.map